import { useState } from "react";
import { FileSpreadsheet, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { downloadExport, downloadFile, errMsg } from "@/lib/api";

export const DownloadButton = ({ path, params, testid, label = "Download Excel" }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { await downloadFile(path, params); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Button variant="outline" size="sm" onClick={run} disabled={busy} data-testid={testid}
      className="border-emerald-300 text-emerald-700 hover:bg-emerald-50 hover:text-emerald-800">
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileSpreadsheet className="h-4 w-4" />}
      {label}
    </Button>
  );
};

export const ExportButton = ({ kind, params, label = "Export Excel" }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      await downloadExport(kind, params);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button variant="outline" size="sm" onClick={run} disabled={busy} data-testid={`export-${kind}-btn`}
      className="border-emerald-300 text-emerald-700 hover:bg-emerald-50 hover:text-emerald-800">
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileSpreadsheet className="h-4 w-4" />}
      {label}
    </Button>
  );
};

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between fade-up">
    <div>
      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight" data-testid="page-title">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
  </div>
);

export const Loading = () => (
  <div className="flex items-center gap-2 py-16 justify-center text-muted-foreground" data-testid="loading">
    <Loader2 className="h-5 w-5 animate-spin text-primary" /> Loading…
  </div>
);
